import { Popover as AntdPopover } from "antd";
import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const Popover = ({
  children,
  contentItems,
  isOpen,
  onOpenChange,
  trigger = "click",
  placement = "leftBottom",
  showArrow = false,
  overlayClassName,
  ...props
}) => (
  <AntdPopover
    content={contentItems}
    trigger={trigger}
    open={isOpen}
    onOpenChange={onOpenChange}
    placement={placement}
    showArrow={showArrow}
    overlayClassName={classNames(styles.overlay, overlayClassName)}
    {...props}
  >
    {children}
  </AntdPopover>
);

export default Popover;
